/* import __COLOCATED_TEMPLATE__ from './insertion-pointer.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
let InsertionPointer = (_class = class InsertionPointer extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isLocked", _descriptor, this);
    _initializerDefineProperty(this, "insertionPointRect", _descriptor2, this);
  }
  get lineStyle() {
    let insertionPoint = this.insertionPointRect;
    return sanitizeHtml(`width: ${insertionPoint.width}px;
      top: ${insertionPoint.top}px;
      left: ${insertionPoint.left}px`);
  }
  get popoverOffset() {
    return [0, -14];
  }
  setInsertionRect() {
    this.insertionPointRect = this.args.composer.state.hoverInfo.nearestInsertionPoint?.rect || new DOMRect(0, 0, 0, 0);
  }
  updateInsertionRect() {
    if (!this.isLocked) {
      this.setInsertionRect();
    }
  }
  lock() {
    this.isLocked = true;
  }
  unlock() {
    this.isLocked = false;
    this.setInsertionRect();
  }
  get notBetweenContainers() {
    if (!this.args.composer.config.tables.containers) {
      return true;
    }
    let currentInsertionPoint = this.args.composer.state.hoverInfo?.nearestInsertionPoint || null;

    // If there is no insertion position don't display the inserter
    if (currentInsertionPoint === null || currentInsertionPoint?.pos === null) {
      return false;
    }
    let node = this.args.composer.state.prosemirrorState.doc.nodeAt(currentInsertionPoint.pos);

    // Hide the insertion pointer if the insertion node is a container table
    if (node?.type === this.args.composer.schema.nodes.table && node?.attrs.container) {
      return false;
    } else {
      return true;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isLocked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "insertionPointRect", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new DOMRect(0, 0, 0, 0);
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateInsertionRect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInsertionRect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "lock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unlock"), _class.prototype), _class);
export { InsertionPointer as default };